module.exports = __webpack_public_path__ + "static/media/shop-category-ktp.f5037052.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/shop-category-ktp.svg
// module id = 930
// module chunks = 0